define('modules/accounts/status/view',['require','exports','module','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");

    var Main = BaseView.extend({
        template: require("ldsh!./template"),
        initialize: function() {},
        beforeRender: function() {
        },
        serialize: function() {
            return {
                activeTab: this.activeTab,
                model: this.model // group
            };
        }
    });

    module.exports = Main;
});

